export default "__VITE_ASSET__BnaCyWPz__"